Vue.component('ConsultantIndexComponent', require('./components/ConsultantsIndexComponent').default);
Vue.component('ConsultantGetComponent', require('./components/ConsultantFormComponent').default);
Vue.component('ConsultantsDataTable', require('./components/partials/ConsultantsDataTable').default);
Vue.component(
    'ConsultantFormMainDetails',
    require('./components/partials/form-partials/ConsultantFormMainDetails').default
);
Vue.component('ConsultantFormOutHours', require('./components/partials/form-partials/ConsultantFormOutHours').default);
Vue.component('ConsultantFormActions', require('./components/partials/form-partials/ConsultantFormActions').default);
